import { detailsListGridErrorText } from './shared-styles';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const mmcGridStyles = ({ iconFontFamily, palette }) => ({
  boxShadow: '0px 3.2px 7.2px rgba(0, 0, 0, 0.132), 0px 0.6px 1.8px rgba(0, 0, 0, 0.108)',
  marginLeft: '28px',
  '& .mmc-grid': {
    width: '400px',
    overflowX: 'hidden',
    // Sets DetailsList to trigger a vertical scrollbar at > 3 rows
    '& .ms-DetailsList-contentWrapper': {
      height: '129px',
      overflowX: 'hidden',
    },
    '& .ms-FocusZone': {
      paddingTop: '0px',
    },
    // ID column
    '& .ms-DetailsRow-cell[aria-colindex="1"]': {
      width: '85px !important',
    },
    '& .ms-DetailsHeader-cell[data-item-key="column1"]': {
      width: '85px !important',
    },
    // Adjust distance of the 3rd column's data from scrollbar
    '& .ms-DetailsRow-cell[aria-colindex="3"]': {
      width: '152px !important',
    },
    '& .ms-DetailsRow-cell': {
      cursor: 'pointer',
    },
  },
  '& .mmc-grid-error': {
    '& .ms-DetailsList-contentWrapper': {
      height: '0px !important',
    },
  },
  '& .ms-SearchBox': {
    marginBottom: '7px',
    borderColor: '#F3F2F1',
  },
  '& .mmc-grid-available-stores': {
    fontWeight: 'bold',
    marginLeft: '12px',
  },
  '& .mmc-grid-error-text': detailsListGridErrorText(),
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const mappingEditorStyles = ({ iconFontFamily, palette }) => ({
  marginLeft: '20px',
  marginBottom: '20px',
  '& .ms-Label': {
    marginTop: '10px',
    '& .description-text': {
      fontWeight: 'bold',
    },
    '& .description-text-2': {
      marginTop: '10px',
      fontWeight: 'normal',
    },
  },
  '& .ms-ChoiceFieldLabel': {
    fontWeight: 'normal',
  },
  // Fix the vertical alignment of the radio button itself (unchecked and checked)
  '& .ms-ChoiceField-field::before': {
    marginTop: '5px',
  },
  '& .ms-ChoiceField-field::after': {
    marginTop: '5px',
  },
  '& .recommended-radio-item': {
    fontWeight: 'bold',
    display: 'inline-block',
    marginLeft: '5px',
    marginTop: '5px',
  },
  '& .mapping-editor-buttons': {
    marginTop: '20px',
  },
  '& .mapping-editor-cancel-button': {
    marginLeft: '12px',
  },
  '& .mmc-grid-css-wrapper': mmcGridStyles({ iconFontFamily, palette }),
});

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const mappingEditorCalloutStyles = ({ iconFontFamily, palette }) => ({
  width: '546px',
  minHeight: '192px',
  '& .two-radio-items-small': {
    maxHeight: '192px',
  },
  '& .two-radio-items-large': {
    maxHeight: '492px',
  },
  '& .three-radio-items-large': {
    maxHeight: '550px',
  },
  '& .ms-Callout-beak': {
    display: 'none',
  },
  '& .mapping-editor': mappingEditorStyles({ iconFontFamily, palette }),
});
